export default __webpack_public_path__ + "static/media/mechz1186X80Png.d90996f1.png";